import LogRocket from "logrocket";

export const logRocketOnError = (message: string) => {
    LogRocket.captureMessage(message);
};
